import React from "react";
import "./Loading.scss";

const LoadSpinner = ({ text }) => (
  <div>
    <div className="loading">
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div className="sendingForm">{text || "Form gönderiliyor..."}</div>
  </div>
);

export default LoadSpinner;
